

/* GoClove PLP — Sticky bar z-index only when stuck */
(function () {
  const GUARD = "__GOC_STICKY_BAR_Z__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  const BAR_SEL = ".gocplp__bar";

  function initBar(bar){
    if (!bar || bar.__gocStickyInit) return;
    bar.__gocStickyInit = true;

    const sentinel = document.createElement("div");
    sentinel.className = "gocplp__barSentinel";
    sentinel.setAttribute("aria-hidden", "true");
    bar.parentNode.insertBefore(sentinel, bar);

    const top = parseInt(getComputedStyle(bar).top || "0", 10) || 0;

    const io = new IntersectionObserver((entries) => {
      const e = entries[0];
      bar.classList.toggle("is-stuck", e.intersectionRatio === 0);
    }, {
      threshold: [0, 1],
      rootMargin: `-${top}px 0px 0px 0px`
    });

    io.observe(sentinel);
    bar.__gocStickyIO = io;
  }

  function scan(){
    document.querySelectorAll(BAR_SEL).forEach(initBar);
  }

  scan();

  const mo = new MutationObserver(() => scan());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
